var exports = {
  "Qq": "ChannelReplyBar.module__text___QXYyYm",
  "Y_": "ChannelReplyBar.module__replyTargetButton___QXYyYm",
  "fh": "ChannelReplyBar.module__authorName___QXYyYm",
  "ne": "ChannelReplyBar.module__controls___QXYyYm",
  "xS": "ChannelReplyBar.module__mentionToggle___QXYyYm",
  "If": "ChannelReplyBar.module__mentionToggleOn___QXYyYm",
  "G9": "ChannelReplyBar.module__mentionToggleOff___QXYyYm",
  "mM": "ChannelReplyBar.module__mentionIcon___QXYyYm",
  "b": "ChannelReplyBar.module__closeButton___QXYyYm",
  "ut": "ChannelReplyBar.module__closeIcon___QXYyYm",
};

module.exports = exports;
